import { ReadonlySignal } from '@funtech-int/rival';
import { useSignal } from '@funtech-int/rival-react';
import * as React from 'react';
import type { FC, MouseEventHandler } from 'react';

interface CarouselNavProps {
    className?: string;
    signal: ReadonlySignal<boolean>;
    onClick: VoidFunction;
    onMouseEnter?: MouseEventHandler<HTMLButtonElement>;
    onMouseLeave?: MouseEventHandler<HTMLButtonElement>;
}

export const CarouselNav: FC<CarouselNavProps> = ({
    className,
    signal,
    onClick,
    onMouseEnter,
    onMouseLeave,
}) => {
    const disabled = useSignal<boolean>(signal);

    return (
        <button
            className={className}
            onClick={onClick}
            disabled={disabled}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        />
    );
};
